// src/components/Sidebar.jsx
import React, { useState } from "react";

const NAV_ITEMS = [
  { id: "dashboard",    label: "Dashboard",      icon: "📊" },
  { id: "blogs",        label: "Blogs",           icon: "📝" },
  { id: "magazine",     label: "Magazine",        icon: "📰" },
  { id: "gallery",      label: "Gallery",         icon: "🖼️" },
  { id: "agriknowledge",label: "AgriKnowledge",   icon: "🌱" },
  { id: "authors",      label: "Authors",         icon: "👤" },
  { id: "categories",   label: "Categories",      icon: "🏷️" },
];

export default function Sidebar({ user, isAdmin, activeSection, onSection, onLogout }) {
  const [open, setOpen] = useState(true);

  return (
    <aside style={{
      width: open ? 230 : 64, flexShrink: 0, background: "#1a3a1e",
      display: "flex", flexDirection: "column", transition: "width 0.2s",
      overflow: "hidden", minHeight: "100vh",
    }}>
      {/* Header */}
      <div style={{
        padding: open ? "20px 18px 16px" : "20px 0 16px", borderBottom: "1px solid #2d5a32",
        display: "flex", alignItems: "center",
        justifyContent: open ? "space-between" : "center",
      }}>
        {open && (
          <div>
            <div style={{ fontSize: 17, fontWeight: 900, color: "#fff", letterSpacing: -0.3 }}>
              🌾 AgriPragati
            </div>
            <div style={{ fontSize: 10, color: "#7ab880", marginTop: 2, letterSpacing: 0.5 }}>
              CMS DASHBOARD
            </div>
          </div>
        )}
        <button
          onClick={() => setOpen(p => !p)}
          style={{
            background: "none", border: "none", color: "#7ab880", cursor: "pointer",
            fontSize: 18, padding: "4px", borderRadius: 6, transition: "color 0.2s",
          }}
          title={open ? "Collapse sidebar" : "Expand sidebar"}
        >
          {open ? "◀" : "▶"}
        </button>
      </div>

      {/* Navigation */}
      <nav style={{ flex: 1, paddingTop: 8 }}>
        {NAV_ITEMS.map(item => {
          const isActive = activeSection === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onSection(item.id)}
              title={!open ? item.label : ""}
              style={{
                width: "100%", background: isActive ? "#2d7a3a" : "transparent",
                border: "none", color: isActive ? "#fff" : "#7ab880",
                padding: open ? "11px 18px" : "11px 0",
                cursor: "pointer", display: "flex", alignItems: "center",
                gap: open ? 10 : 0, justifyContent: open ? "flex-start" : "center",
                fontSize: 14, fontFamily: "inherit", fontWeight: isActive ? 700 : 400,
                transition: "all 0.15s", borderLeft: isActive ? "3px solid #7ab880" : "3px solid transparent",
              }}
              onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = "#243b27"; }}
              onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = "transparent"; }}
            >
              <span style={{ fontSize: 18 }}>{item.icon}</span>
              {open && item.label}
            </button>
          );
        })}
      </nav>

      {/* User profile + logout */}
      <div style={{ padding: open ? "14px 18px" : "14px 8px", borderTop: "1px solid #2d5a32" }}>
        {open ? (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
              {user.photoURL ? (
                <img src={user.photoURL} alt="" style={{ width: 36, height: 36, borderRadius: "50%", flexShrink: 0 }} />
              ) : (
                <div style={{
                  width: 36, height: 36, borderRadius: "50%", background: "#2d7a3a", flexShrink: 0,
                  display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15, fontWeight: 700,
                }}>
                  {user.displayName?.charAt(0) || "U"}
                </div>
              )}
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#fff", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {user.displayName}
                </div>
                <div style={{ fontSize: 11, color: "#7ab880" }}>
                  {isAdmin ? "🛡 Admin" : "👁 Viewer"}
                </div>
              </div>
            </div>
            <button
              onClick={onLogout}
              style={{
                width: "100%", background: "#b91c1c", border: "none", color: "#fff",
                borderRadius: 8, padding: "8px 0", fontSize: 12, fontFamily: "inherit",
                cursor: "pointer", fontWeight: 600, transition: "background 0.15s",
              }}
              onMouseEnter={e => (e.currentTarget.style.background = "#991b1b")}
              onMouseLeave={e => (e.currentTarget.style.background = "#b91c1c")}
            >
              Sign Out
            </button>
          </>
        ) : (
          <button
            onClick={onLogout}
            title="Sign Out"
            style={{ background: "none", border: "none", color: "#7ab880", cursor: "pointer", fontSize: 20, display: "block", margin: "0 auto" }}
          >
            🚪
          </button>
        )}
      </div>
    </aside>
  );
}
